import axiosInstance from "./service-instance";
import { createUrl } from "utilities";
import { CONTENT_TYPES } from "constants";

const CASE_LIST_URL = createUrl(["case", "list"]);

const getCases = (caseStatus, stageId, page, page_size, search) =>
    axiosInstance.get(CASE_LIST_URL, {
        params: {
            page,
            page_size,
            status: JSON.stringify([]),
            type: caseStatus.toLowerCase(),
            stage: JSON.stringify([stageId]),
            search: search
        },
        headers: {
            "Content-Type": CONTENT_TYPES.APPLICATION_JSON
        }
    });

export default {
    getCases
};
